import { Alert, Button, Modal } from 'antd';

const projectWord = (n) => (n === 1 ? 'projektu' : 'projektih');

const ProjectList = ({ projects }) => (
  <ul style={{ margin: '8px 0 0', paddingLeft: 20, maxHeight: 220, overflow: 'auto' }}>
    {projects.map(p => <li key={p.id}>{p.title}</li>)}
  </ul>
);

/**
 * Categories are shared across the whole organization, so both deleting and
 * renaming one reaches every project budget that uses it. `blocked` explains a
 * refused delete, `rename` asks for confirmation before a rename goes through.
 */
const CategoryUsageModal = ({ open, mode, usage, onOk, onCancel }) => {
  const projects = usage?.projects || [];
  const intentCount = usage?.intent_count || 0;
  const inBudgets = (usage?.plan_row_count || 0) > 0;
  const isBlocked = mode === 'blocked';

  return (
    <Modal
      title={isBlocked ? 'Kategorije ni mogoče izbrisati' : 'Sprememba bo vplivala na proračune projektov'}
      open={open}
      onCancel={onCancel}
      footer={
        isBlocked
          ? [<Button key="close" onClick={onCancel}>Zapri</Button>]
          : [
              <Button key="cancel" onClick={onCancel}>Prekliči</Button>,
              <Button key="ok" type="primary" onClick={() => onOk()}>Potrdi</Button>,
            ]
      }
    >
      {isBlocked ? (
        <Alert
          type="error"
          showIcon
          message="Kategorija je v uporabi"
          description={
            <>
              <span>
                {inBudgets
                  ? 'Brisanje bi odstranilo ta odsek iz proračunov projektov, ki ga uporabljajo. Najprej ga odstranite iz teh projektov.'
                  : 'Brisanje bi odvzelo kategorijo transakcijam, ki so nanjo vezane. Najprej jim dodelite drugo kategorijo.'}
              </span>
              {projects.length > 0 && <ProjectList projects={projects} />}
            </>
          }
        />
      ) : (
        <>
          <p>
            Ta kategorija se uporablja v <b>{projects.length} {projectWord(projects.length)}</b>.
            {inBudgets
              ? ' Nov naziv se bo prikazal v proračunih vseh naštetih projektov.'
              : ' Nov naziv bo veljal povsod, kjer je kategorija v uporabi.'}
          </p>
          {projects.length > 0 && <ProjectList projects={projects} />}
        </>
      )}

      {intentCount > 0 && (
        <p style={{ marginTop: 12, marginBottom: 0 }}>
          Pripeta je tudi na <b>{intentCount}</b> transakcij.
        </p>
      )}
    </Modal>
  );
};

export default CategoryUsageModal;
